import { useCopiedState } from "../../../../core/util/hooks";
import { setFilter, removeFilter, initialState } from "../dividendsUXSlice"
import { invalidateDividends } from "../dividendsDataSlice"
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import React from "react";
import { DividendFilter } from "../types";


export const useDividendsFilter = () => {
	const storeFilter = useSelector<StoreType, DividendFilter>(store => store.ux.reports.dividends.filter);
	const [filter, editFilter, changeState, setCurrentFilter] = useCopiedState<DividendFilter>(storeFilter);

	const dispatch = useDispatch();
	const dispatchSetFilter = React.useCallback(() => {
		dispatch(setFilter(filter!))
		dispatch(invalidateDividends())
	}, [dispatch, filter])

	const dispatchResetFilter = React.useCallback(() => {
		setCurrentFilter(initialState.filter)
	}, [setCurrentFilter])

	return [
		filter,
		editFilter,
		dispatchSetFilter,
		changeState, 
		dispatchResetFilter
	] as [
		typeof filter,
		typeof editFilter,
		typeof dispatchSetFilter,
		typeof changeState,
		typeof dispatchResetFilter
	]
};

export const useCurrentDividendsFilter = () => {
	const filter = useSelector<StoreType, DividendFilter>(store => store.ux.reports.dividends.filter);
	const dispatch = useDispatch();
	const dispatchRemoveFilter = React.useCallback(
		(type: keyof DividendFilter) => {
			dispatch(removeFilter(type));
			dispatch(invalidateDividends());
		},
		[dispatch]
	);

	return [filter, dispatchRemoveFilter] as [typeof filter, typeof dispatchRemoveFilter];
};
